import { QueryHookOptions } from '@apollo/client';
import { useQuery } from '@ts-gql/apollo';
import { OperationData, OperationVariables, gql } from '@ts-gql/tag';
import React from 'react';

export const SEARCH_CLIENTS_QUERY = gql`
  query SearchClients(
    $searchTerm: String!
    $includeNonClients: Boolean!
    $take: Float!
  ) {
    searchClients(
      searchTerm: $searchTerm
      includeNonClients: $includeNonClients
      take: $take
    ) {
      cloudId
      name
      endDateUtc
      isDeleted
    }
  }
` as import('../../__generated__/ts-gql/SearchClients').type;

export type SearchClientsQueryVariables = OperationVariables<
  typeof SEARCH_CLIENTS_QUERY
>;
export type SearchClientsQueryResult = OperationData<
  typeof SEARCH_CLIENTS_QUERY
>;

export type SearchClientsResult = NonNullable<
  SearchClientsQueryResult['searchClients']
>[number];

export const useSearchClients = (
  options: QueryHookOptions<
    SearchClientsQueryResult,
    SearchClientsQueryVariables
  >
) => {
  const variables = options.variables as SearchClientsQueryVariables;

  const res = useQuery(SEARCH_CLIENTS_QUERY, {
    context: { service: 'clients' },
    variables,
    ...options,
  });

  return React.useMemo(
    () => ({ ...res, data: res.data?.searchClients }),
    [res]
  );
};
